// src/services/CategoriasService.js

const API = "/api/categorias";

export const getCategorias = async () => {
  const res = await fetch(API);
  return await res.json();
};

export const saveCategoria = async (data) => {
  const res = await fetch(API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });

  return await res.json();
};